import React from "react";
import { useMemo } from "react";

const range = (start, end) => {
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const usePagination = ({
  totalCount,
  pageSize,
  siblingCount = 1,
  currentPage,
}) => {
  const paginationRange = useMemo(() => {
    pageSize = pageSize ?? 10;
    let startPage, endPage;
    const totalPageCount = Math.ceil(totalCount / pageSize);
    if (totalPageCount <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPageCount;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPageCount) {
        startPage = totalPageCount - 9;
        endPage = totalPageCount;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }
    return range(startPage, endPage);
  }, [totalCount, pageSize, siblingCount, currentPage]);

  return paginationRange;
};
